module.exports = __webpack_public_path__ + "ea0a4561239b0b5b6ccd034ffc923289.ico";